import React from 'react';

import FormField from 'grommet/components/FormField';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';

export default class Conditional extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = {
      isOpen: props.isOpen || false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hasOwnProperty('isOpen')) {
      this.setState({ isOpen: nextProps.isOpen })
    }
  }

  onChange() {
    this.setState({ isOpen: !this.state.isOpen }, () => {
      this.props.onChange && this.props.onChange(this.state.isOpen);
    });
  }

  render () {
    const {
      children,
      isOpen, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      ...rest,
    } = this.props;

    return (
      <Box>
        <FormField>
          <CheckBox
            checked={this.state.isOpen}
            onChange={this.onChange}
            name={rest.id}
            {...rest} />
        </FormField>
        {this.state.isOpen && children}
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Conditional.js